import { Box } from '@mui/material';
import { useMemo } from 'react';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { getChildHeadingId } from '../CreditCardsTableOfContents/utils';
export type CreditCardsTableOfContentsSectionProps = StructuredContentDocumentWithRenderer<{
  heading: string;
  children: StructuredContentDocument;
}>;
export const CreditCardsTableOfContentsSection = (sccProps: CreditCardsTableOfContentsSectionProps) => {
  const {
    props: {
      children
    }
  } = sccProps;
  const headingId = useMemo(() => getChildHeadingId(sccProps), [sccProps.props.children]);
  return <Box className="table-of-contents-section" sx={{
    '& > div:not(:first-child)': {
      paddingX: {
        sm: 3
      }
    }
  }} component="section" aria-labelledby={headingId}>
      {renderStructuredContent(children)}
    </Box>;
};